export default "__VITE_ASSET__f8150545__"